import { Capacitor } from '@capacitor/core';

type FrameContext = { self: Window; top: Window | null };

// A host app may expose its Capacitor bridge to LAD's iframe. Embedded LAD
// must use web behavior rather than the host app's native plugins.
export function getAppPlatform(context: FrameContext = window): string {
  // eslint-disable-next-line no-restricted-properties -- Only this utility may use raw Capacitor platform detection.
  return context.self !== context.top ? 'web' : Capacitor.getPlatform();
}

export function isNativeApp(context: FrameContext = window): boolean {
  return getAppPlatform(context) !== 'web';
}
